import { Injectable } from "@angular/core";
import { SearchTileInterface } from "src/app/core/interfaces/tile-interface";
import { BackendService } from "src/app/core/services/backend-service";

@Injectable({
  providedIn: "root",
})
export class SearchService extends BackendService {
  async getSearchResults(query: string): Promise<SearchTileInterface> {
    try {
      const url = `api/search/tiles?searchTerm=${encodeURIComponent(query.trim())}`;
      const results = await this.get<SearchTileInterface>(url);
      return results;
    } catch (error) {
      console.error("Error searching tiles");
      return;
    }
  }
}
